import { render, staticRenderFns } from "./UserOption.vue?vue&type=template&id=5e2e5017&scoped=true&"
import script from "./UserOption.vue?vue&type=script&lang=ts&"
export * from "./UserOption.vue?vue&type=script&lang=ts&"
import style0 from "./UserOption.vue?vue&type=style&index=0&id=5e2e5017&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e5017",
  null
  
)

export default component.exports